import React from "react";
import { FormControl, Grid, Typography, Box, TextField } from "@mui/material";
import FormAutoComplete from "../../../../components/FormAutoComplete";
import { countryList } from "../../../../constants";
import useTranslation from "../../../../hooks/translations";
import { Countries, Country } from "../../../../types";
interface CountrySectionProps {
  formik: any;
  onChangeCountry: (country: any) => void;
  selectedOption: Country ;
  availableCountries: Countries[];
}

const CountrySection: React.FC<CountrySectionProps> = ({
  formik,
  onChangeCountry,
  selectedOption,
  availableCountries,
}) => {
  const { t } = useTranslation();

  const options = availableCountries.length > 0 ? availableCountries : [];
  return (
    <Box sx={{ marginTop: 2 }}>
      <Grid item>
        <FormControl
          className={"fieldset form-control"}
          component="fieldset"
          error
          fullWidth
        >
          <Typography component="legend" className={"fieldTitleSecondary"}>
            {t("country")} <span style={{ fontSize: 14, color: "red" }}>*</span>
          </Typography>
          <FormAutoComplete
            fullWidth
            resource="country"
            options={options}
            defaultValue={countryList.find((item) => item?.name === "Cameroon")}
            disableClearable
            variant={"outlined"}
            type={"country"}
            label={""}
            onChange={(country) => onChangeCountry(country)}
            selectedOption={selectedOption}
            size="small"
            loading={false}
            readOnly={false}
            dataTestId="country-autocomplete"
            renderInput={(params) => <TextField {...params} />}
          />
        </FormControl>

        {
          <Typography
            pb={2}
            pl={2}
            style={{
              color: "#d32f2f",
              fontSize: "0.75rem",
            }}
          >
            {formik.errors.country}
          </Typography>
        }
      </Grid>
    </Box>
  );
};

export default CountrySection;
